import dayjs from "dayjs";
import { roundUp, formatDate } from "./helpers";

export function recalculateAbono({
  ultimoAbono,
  antesUltimoAbono,
  scheduleWithPayments,
  pagosHechos,
  monthlyRate,
  monthlyPayment,
  startDate,
}) {
  const startInstallment = Number(
    ultimoAbono.startInstallment || pagosHechos + 1
  );

  const cuotasPagadas = scheduleWithPayments.filter(
    (c) => c.cuota < startInstallment
  );

  const saldoRestante = Number(ultimoAbono.ammount);
  const recalculoTipo = ultimoAbono.type;
  const planVersion = (antesUltimoAbono?.planVersion ?? 1) + 1;

  const ultimaCuotaPagada = cuotasPagadas[cuotasPagadas.length - 1];
  let paymentDate = ultimaCuotaPagada
    ? dayjs(ultimaCuotaPagada.fechaPago.split("/").reverse().join("-"))
    : startDate;

  function generarNuevasCuotas(tipo, mesesRestantesParam) {
    let nuevasCuotas = [];
    let balance = saldoRestante;

    const mesesRestantes =
      mesesRestantesParam ?? scheduleWithPayments.length - cuotasPagadas.length;

    const nuevaCuota =
      tipo === "mantener"
        ? monthlyPayment
        : saldoRestante *
          (monthlyRate / (1 - Math.pow(1 + monthlyRate, -mesesRestantes)));

    for (
      let i = startInstallment, count = 1;
      count <= mesesRestantes && balance > 0;
      i++, count++
    ) {
      paymentDate = paymentDate.add(1, "month");
      const year = paymentDate.year();
      const month = paymentDate.month();
      const adjustedDay = month === 1 ? 28 : 30;
      paymentDate = dayjs(`${year}-${month + 1}-${adjustedDay}`, "YYYY-M-D");

      const interest = balance * monthlyRate;
      const capital = nuevaCuota - interest;
      balance -= capital;
      if (balance < 0) balance = 0;

      nuevasCuotas.push({
        cuota: i,
        payment: false,
        fechaPago: formatDate(paymentDate),
        valorPrestamo: balance + capital,
        cuotaAPagar: roundUp(nuevaCuota),
        capital: roundUp(capital),
        interes: roundUp(interest),
        saldoDeuda: roundUp(balance),
        planVersion,
      });

      if (balance <= 0) break;
    }

    return nuevasCuotas;
  }

  let nuevasCuotas = [];

  if (recalculoTipo === "recalcular") {
    nuevasCuotas = generarNuevasCuotas(
      "recalcular",
      antesUltimoAbono?.remainingMonths
    );
  } else if (recalculoTipo === "mantener") {
    nuevasCuotas = generarNuevasCuotas("mantener");
  } else if (recalculoTipo === "recalculo_plazo") {
    nuevasCuotas = generarNuevasCuotas(
      "recalcular",
      Number(ultimoAbono.remainingMonths ?? 1)
    );
  }

  return {
    nuevoSchedule: [...cuotasPagadas, ...nuevasCuotas],
    nuevoPlanVersion: planVersion,
  };
}
